import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'; // Make sure this is imported

import './assets/styles.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const app = createApp(App);

app.use(router);
app.use(store); // Ensure store is registered here

app.mount('#app');
// In main.js

// Function to toggle sidebar visibility on mobile
function toggleSidebar() {
    document.body.classList.toggle('sidebar-open');
  }
  
  // Add event listener to sidebar toggle button (if using vanilla JavaScript)
  document.querySelector('.navbar-toggler').addEventListener('click', toggleSidebar);
  
